import _ from "lodash";
import Big from "big.js";

/**
 * 税抜き価格を計算する
 * @param price
 */
export const taxPrice = (price: number) => {
  // big.jsを使用して消費税算出
  return Big(_.toNumber(price)).times(0.1).round(0, Big.roundUp).toNumber();
}

/**
 * 税込み価格を計算する
 * @param price
 */
export const taxIncludedPrice = (price: number | string | undefined) => {
  if (price) {
    // big.jsを使用して消費税計算（切り上げ）
    return Big(_.toNumber(price)).times(1.1).round(0, Big.roundUp).toNumber();
  }
  return 0;
}

/**
 * 税を抜いた価格を取得
 */
export const taxExcludedPrice = (price: number | string | undefined) => {
  if (price) {
    return Math.ceil(_.toNumber(price) / 1.1);
  }

  return 0;
}

/**
 * 消費税を取得
 */
export const consumptionTax = (price: number | string | undefined) => {
  if (price) {
    return Big(_.toNumber(price)).times(0.1).round(0, Big.roundUp).toNumber();
  }

  return 0;
}
